import { AdminLayout } from '../components/layout/AdminLayout'

export function StaffPage() {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Gestión de Staff</h1>
          <p className="text-gray-600 mt-1">Administra el equipo administrativo</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-500">Vista de staff - En construcción</p>
        </div>
      </div>
    </AdminLayout>
  )
}
